import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import * as moment from 'moment';
import * as _ from 'lodash';

import { LoaderEvent } from './../../shared/message.event';
import { PrimecalendarService } from './../primecalendar.service';
import { UtilityFunctions } from '../../shared/utility-functions';
import { AppService } from '../../app.service';
import { Invoice } from './../Invoice';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { CONSTANT_VALUES } from '../../constants/constant-values';


@Component({
  selector: 'app-guest-booking',
  templateUrl: './guest-booking.component.html',
  styleUrls: ['./guest-booking.component.css'],
  providers: [
    LoaderEvent, PrimecalendarService, AppService
  ],
  exportAs: 'bookingPopUpObj'
})
export class GuestBookingComponent implements OnInit {
  private confirmation = 'Confirmation';
  @ViewChild('childModalBooking') childModal: ModalDirective;
  @Input() message = '';
  @Input() popupTitle;
  @Input() deleteMessage;
  @Input() eventData;
  @Input() selectedUnit;
  @Input() category;
  @Input() facilityCloseTime;
  @Input() calendarDate = '';
  @Input() facility;
  @Output() notify = new EventEmitter<boolean>();
  @Output() notifyDelete = new EventEmitter<boolean>();
  @Output() callBookingAPI = new EventEmitter<any>();
  @Output() refreshPage = new EventEmitter<boolean>();

  private bookingObj = {
    emailId: '',
    contactNumber: '',
    firstName: '',
    membershipId: '',
    userId: '',
    attendees: '1',
    hours: '',
    startTime_hours: '',
    startTime_minutes: '',
    endTime: '',
    type: '',
    lastName: '',
    isForcedBooking: false,
    countryCode: '+65',
    bookingSlots: '1',
    addressLine1: '',
    addressLine2: '',
    note: '',
    groupNames: '',
    groups: [],
    bookingVendorNote: ''
  };
  private validate = {
    emailId: '',
    contactNumber: '',
    firstName: '',
    membershipId: '',
    attendees: '',
    hour: '',
    flag: false,
    bookingStart_hours: '',
    bookingStart_minutes: '',
    endTime: '',
    type: '',
    lastName: '',
    isForcedBooking: false,
    countryCode: '',
    bookingSlots: '',
    memberIdOrFirstName: '',
    repeatCount: ''
  };
  private isContactDisable = true;
  private memberList = [];
  private isEmailIdDisable = true;
  private popUpMessage = '';
  private vendor;
  private showHour = false;
  private _appService;
  private noOfPeopleErrorMsg = '';
  private timezoneOffset;
  private utilityFunctions = new UtilityFunctions();
  private ActivityStartTimeHoursList = [];
  private minutes_value = CONSTANT_VALUES.MINUTE_VALUES;
  private bookingStart_hours = '';
  private bookingStart_minutes = '';
  private bookingEnd_hours = '';
  private bookingEnd_minutes = '';
  private endTime = '';
  private errMessage = '';
  private disableIncreaseIcon = false;
  private disableDecreaseIcon = true;
  private disableDecreaseIconOfSlots = true;
  private nocursorplus = '';
  private nocursor = '';
  private noCursorSlots = '';
  private bookingStartLockOn = '';
  private blockPrev = false;
  private blockNext = false;
  private showAddMemberMessage = false;
  private showAddMemberFields = false;
  private isShowAllowForceBooking = false;
  private isShowCanBeForceBookedMessage = false;
  private bookButtonText = '';
  private memberAddedSuccesfullyMsg = '';
  private userId = '';
  private bookingPopupMessage = '';
  private countryCodes;
  private isopen1 = false;
  private memberIdOrFirstName = '';
  private repeatCount = 0;
  private requestForRepeat;
  private statusChecked = false;
  private isShowContinueBookingMessage = false;
  private continueBookingMessage = '';
  private statusOFBookings = [];
  private checkAvailability = false;
  private showBook = true;
  private memberAddedMessage = '';
  private monthWiseBlock = [];
  private isShowAvailabilityStatus = false;
  private allSlotsUnavailable = false;
  private eventdate;
  private eventStartTime;
  private eventEndTime;
  private stringConstants = CONSTANT_MESSAGES;
  private memberType = CONSTANT_VALUES.MEMBER_TYPE;
  private confirmationBookingResult;
  private paymentDoneMessage = '';
  private bookingConfirmation = true;
  constructor(private loaderEvent: LoaderEvent, private calendarService: PrimecalendarService, private appService: AppService) {
    this._appService = appService;
    this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    this.timezoneOffset = this.vendor.timezoneOffset * -1;
  }

  public showChildModal(): void {
    this.memberIdOrFirstName = '';
    this.testCategory();
    this.isEmailIdDisable = true;
    this.bookingObj = {
      emailId: '',
      contactNumber: '',
      firstName: '',
      membershipId: '',
      userId: '',
      attendees: '1',
      hours: '',
      startTime_hours: '',
      startTime_minutes: '',
      endTime: '',
      type: '',
      lastName: '',
      isForcedBooking: false,
      countryCode: '+65',
      bookingSlots: '1',
      addressLine1: '',
      addressLine2: '',
      note: '',
      groupNames: '',
      groups: [],
      bookingVendorNote: ''
    };
    this.validate = {
      emailId: '',
      contactNumber: '',
      firstName: '',
      membershipId: '',
      attendees: '',
      hour: '',
      flag: false,
      bookingStart_hours: '',
      bookingStart_minutes: '',
      endTime: '',
      type: '',
      lastName: '',
      isForcedBooking: false,
      countryCode: '',
      bookingSlots: '',
      memberIdOrFirstName: '',
      repeatCount: ''
    };
    this.bookingEnd_hours = '';
    this.bookingEnd_minutes = '';
    this.eventdate = this.eventData['startTimeNew'].format('MMM DD YYYY');
    this.eventEndTime = this.eventData['startTimeNew'].format('HH:mm');
    this.disableDecreaseIcon = true;
    this.disableDecreaseIconOfSlots = true;
    this.disableIncreaseIcon = false;
    if (this.disableDecreaseIcon) {
      this.nocursor = 'no-cursor';
    }
    if (this.disableDecreaseIconOfSlots) {
      this.noCursorSlots = 'no-cursor';
    }
    this.nocursorplus = '';
    this.errMessage = '';
    this.childModal.config.backdrop = false;
    if (this.facility.isSlotsLocked) {
      this.calculateBookingSlot();
    } else {
      this.bookingStart_hours = ('0' + this.eventData.startTimeNew.hours()).slice(-2);
      this.bookingStart_minutes = ('0' + this.eventData.startTimeNew.minutes()).slice(-2);
      this.bookingHourValues();
    }
    this.showAddMemberMessage = false;
    this.showAddMemberFields = false;
    this.showSlotTime();
    this.statusOFBookings = [];
    this.checkAvailability = this.facility.isWeeklyRepeatBooking ? true : false;
    this.repeatCount = this.facility.isWeeklyRepeatBooking ? 1 : 0;
    this.statusChecked = false;
    this.continueBookingMessage = '';
    this.memberAddedSuccesfullyMsg = '';
    this.isShowCanBeForceBookedMessage = false;
    this.isShowAllowForceBooking = this.facility.isAllowForceBooking;
    this.memberAddedMessage = '';
    this.isShowAvailabilityStatus = false;
    this.allSlotsUnavailable = false;
    this.monthWiseBlock = [];
    this.bookButtonText = CONSTANT_MESSAGES.BOOK_BUTTON_TEXT;
    this.utilityFunctions.setBackGroundBlack();
    this.childModal.show();
    this.confirmationBookingResult = undefined;
    this.paymentDoneMessage = '';
    this.bookingConfirmation = true;
  }

  public hideChildModal(): void {
    this.utilityFunctions.removeBackGroundBlack();
    this.childModal.hide();
  }

  ngOnInit() {
    this.appService.getAppVersion().then((result: any) => {
      this.countryCodes = result.countryCodes;
    });
  }

  onClickOk() {
    this.notify.emit(true);
  }

  onClickCancle() {
    this.notify.emit(false);
  }

  settUtcFormat(str) {
    let utcHr: string;
    let currDate = new Date();
    let timeArr = [];
    timeArr = str.split(':');
    currDate.setUTCHours(parseInt(timeArr[0]), parseInt(timeArr[1]));
    let hr = currDate.getHours();
    if (hr < 10) {
      utcHr = '0' + hr;
      return utcHr;
    } else {
      return hr.toString();
    }
  }
  /**
   * Validate mandatory fields
   *
   * @param {any} validatePara
   * @param {any} event
   * @returns
   *
   * @memberof GuestBookingComponent
   */
  validationForMandatoryFields(validatePara, event, fromIncr?) {
    try {
      let validateFlag = true;
      if ((event && event.keyCode !== 9) || fromIncr) {
        switch (validatePara) {
          case 'membershipId':
            if (!(this.bookingObj.membershipId + '').trim() || this.bookingObj.membershipId === ' ') {
              this.bookingObj.membershipId = '';
              this.validate.membershipId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              validateFlag = false;
            } else {
              this.validate.membershipId = '';
            }
            break;
          case 'firstName':
            if (!(this.bookingObj.firstName + '').trim() || this.bookingObj.firstName === ' ') {
              this.validate.firstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              validateFlag = false;
            } else {
              this.validate.firstName = '';
            }
            break;
          case 'attendees':
            if (parseInt((this.bookingObj.attendees + '').trim()) < 0 && ((this.bookingObj.attendees + '').trim().indexOf('+') || (this.bookingObj.attendees + '').trim().indexOf('e'))) {
              this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              validateFlag = false;
            } else if (!parseInt(this.bookingObj.attendees) || this.checkAttendeeCount()) {
              this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              validateFlag = false;
              this.showNoOfPeopleErrorMsg();
            } else {
              this.validate.attendees = '';
              this.disableIncreaseIcon = false;
              this.nocursorplus = '';
            }
            if (parseInt(this.bookingObj.attendees) <= 1) {
              this.disableDecreaseIcon = true;
              this.nocursor = 'no-cursor';
            } else {
              this.disableDecreaseIcon = false;
              this.nocursor = '';
            }
            break;
          case 'hour':
            if (this.showHour) {
              if (!(this.bookingObj.hours + '').trim() && ((this.bookingObj.hours + '').trim().indexOf('+') < 0 || (this.bookingObj.hours + '').trim().indexOf('e')) < 0) {
                this.endTime = '';
                this.validate.hour = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                validateFlag = false;
              } else if (!parseInt(this.bookingObj.hours)) {
                this.endTime = '';
                this.validate.hour = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                validateFlag = false;
              }
              else if (parseInt(this.bookingObj.hours) <= 0) {
                this.endTime = '';
                this.validate.hour = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                validateFlag = false;
              } else {
                this.calculateBookingEndTime();
                this.validate.hour = '';
              }
            }
            break;
          case 'start_hour':
            if ((this.bookingStart_hours + '').trim()) {
              this.validate.bookingStart_hours = '';
            } else {
              this.validate.bookingStart_hours = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              validateFlag = false;
            }
            break;
          case 'start_minute':
            if ((this.bookingStart_minutes + '').trim()) {
              this.validate.bookingStart_minutes = '';
            } else {
              this.validate.bookingStart_minutes = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              validateFlag = false;
            }
            break;
          case 'bookingSlots':
            if (this.bookingObj.bookingSlots) {
              this.calculateBookingEndTime();
              this.validate.bookingSlots = '';
            } else {
              this.endTime = '';
              this.validate.bookingSlots = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              validateFlag = false;
            }
            break;
          case 'countryCode':
            if (!(this.bookingObj.countryCode + '').trim()) {
              this.validate.countryCode = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              validateFlag = false;
            } else {
              this.validate.countryCode = '';
            }
            break;
          case 'contactNumber':
            let regEx = /^\d{4,16}$/;
            if ((this.bookingObj.contactNumber + '').trim() && regEx.test(this.bookingObj.contactNumber)) {
              this.validate.contactNumber = '';
            } else {
              this.validate.contactNumber = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              this.validate.flag = false;
            }
            break;
          case '':
            validateFlag = this.validateMandatoryFields();
            break;
          case 'memberIdOrFirstName':
            if (!(this.memberIdOrFirstName + '').trim()) {
              this.validate.memberIdOrFirstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              this.validate.flag = false;
            } else {
              this.validate.memberIdOrFirstName = '';
            }
            break;
          case 'repeat':
            if (this.repeatCount) {
              if (this.repeatCount && parseInt((this.repeatCount + '').trim()) < 1 && ((this.repeatCount + '').trim().indexOf('+') || (this.repeatCount + '').trim().indexOf('e'))) {
                this.validate.repeatCount = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                this.validate.flag = false;
              } else {
                this.validate.repeatCount = '';
              }
            } else {
              this.validate.repeatCount = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              this.validate.flag = false;
            }
        }
      }
      return validateFlag;
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Validate mandatory field
   *
   * @returns
   *
   * @memberof GuestBookingComponent
   */
  validateMandatoryFields() {
    this.validate.flag = true;
    let regEx = /^\d{4,16}$/;
    if (!(this.bookingObj.membershipId + '').trim()) {
      this.validate.membershipId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
    } else {
      this.validate.membershipId = '';
    }
    if (!(this.bookingObj.firstName + '').trim()) {
      this.validate.firstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
    } else {
      this.validate.firstName = '';
    }
    if ((parseInt((this.bookingObj.attendees + '').trim()) < 1) && ((this.bookingObj.attendees + '').trim().indexOf('+') || (this.bookingObj.attendees + '').trim().indexOf('e'))) {
      this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
    } else if (!parseInt(this.bookingObj.attendees) || this.checkAttendeeCount()) {
      this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
      this.showNoOfPeopleErrorMsg();
    } else {
      this.validate.attendees = '';
      this.disableIncreaseIcon = false;
      this.nocursorplus = '';
    }
    if (!this.facility.isSlotsLocked) {
      if (this.bookingStart_hours) {
        this.validate.bookingStart_hours = '';
      } else {
        this.validate.bookingStart_hours = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.flag = false;
      }
      if (this.bookingStart_minutes) {
        this.validate.bookingStart_minutes = '';
      } else {
        this.validate.bookingStart_minutes = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.flag = false;
      }
    } else {
      if (this.bookingStartLockOn) {
        this.validate.bookingSlots = '';
      } else {
        this.validate.bookingStart_hours = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.flag = false;
      }

    }
    if (this.showAddMemberFields) {
      if (this.bookingObj.emailId) {
        if (!this.utilityFunctions.validateEmail(this.bookingObj.emailId)) {
          this.validate.emailId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
          this.validate.flag = false;
        } else {
          this.validate.emailId = ''; '';
        }
      }
      else {
        this.validate.emailId = '';
      }
    } else {
      this.validate.emailId = '';
    }
    if (this.showAddMemberFields) {
      if (!(this.bookingObj.countryCode + '').trim()) {
        this.validate.countryCode = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.flag = false;
      } else {
        this.validate.countryCode = '';
      }
    } else {
      this.validate.countryCode = '';
    }
    if (this.showAddMemberFields) {
      if ((this.bookingObj.contactNumber + '').trim() && regEx.test(this.bookingObj.contactNumber)) {
        this.validate.contactNumber = '';
      } else {
        this.validate.contactNumber = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.flag = false;
      }
    }
    else {
      this.validate.contactNumber = '';
    }
    if (this.bookingObj.bookingSlots) {
      this.validate.bookingSlots = ''
    } else {
      this.validate.bookingSlots = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
    }
    if (!(this.memberIdOrFirstName + '').trim()) {
      this.validate.memberIdOrFirstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
    } else {
      this.validate.memberIdOrFirstName = '';
    }
    if (this.facility.isWeeklyRepeatBooking) {
      if (this.repeatCount) {
        if (this.repeatCount && parseInt((this.repeatCount + '').trim()) < 1 && ((this.repeatCount + '').trim().indexOf('+') || (this.repeatCount + '').trim().indexOf('e'))) {
          this.validate.repeatCount = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
          this.validate.flag = false;
        } else {
          this.validate.repeatCount = '';
        }
      } else {
        this.validate.repeatCount = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.flag = false;
      }
    }
    return this.validate.flag;
  }
  /**
   * Reset all fields
   *
   *
   * @memberof GuestBookingComponent
   */
  resetAll(isFromCancel) {
    this.memberIdOrFirstName = '';
    this.bookingObj = {
      emailId: '',
      contactNumber: '',
      firstName: '',
      membershipId: '',
      userId: '',
      attendees: '1',
      hours: '',
      startTime_hours: '',
      startTime_minutes: '',
      endTime: '',
      type: '',
      lastName: '',
      isForcedBooking: false,
      countryCode: '+65',
      bookingSlots: '1',
      addressLine1: '',
      addressLine2: '',
      note: '',
      groupNames: '',
      groups: [],
      bookingVendorNote: ''

    };
    this.validate = {
      emailId: '',
      contactNumber: '',
      firstName: '',
      membershipId: '',
      attendees: '',
      hour: '',
      flag: false,
      bookingStart_hours: '',
      bookingStart_minutes: '',
      endTime: '',
      type: '',
      lastName: '',
      isForcedBooking: false,
      countryCode: '',
      bookingSlots: '',
      memberIdOrFirstName: '',
      repeatCount: ''
    };
    this.showAddMemberMessage = false;
    this.showAddMemberFields = false;
    this.showSlotTime();
    this.statusOFBookings = [];
    this.checkAvailability = this.facility.isWeeklyRepeatBooking ? true : false;
    this.repeatCount = this.facility.isWeeklyRepeatBooking ? 1 : 0;
    this.statusChecked = false;
    this.continueBookingMessage = '';
    this.memberAddedSuccesfullyMsg = '';
    this.isShowCanBeForceBookedMessage = false;
    this.isShowAllowForceBooking = this.facility.isAllowForceBooking;
    this.memberAddedMessage = '';
    this.isShowAvailabilityStatus = false;
    this.allSlotsUnavailable = false;
    this.bookButtonText = CONSTANT_MESSAGES.BOOK_BUTTON_TEXT;
    this.bookingObj.bookingSlots = '1';
    this.showAddMemberFields = false;
    this.errMessage = '';
    this.statusOFBookings = [];
    this.memberList = [];
    this.allSlotsUnavailable = true;
    this.monthWiseBlock = [];
    this.showBook = true;
    if (isFromCancel) {
      this.hideChildModal();
    }
  }
  /**
   * Call booking API
   *
   * @param {any} popUpObj
   *
   * @memberof GuestBookingComponent
   */
  bookingRequest(popUpObj, msgPopUpObj) {
    this.loaderEvent.fire(false);
    let memberData;
    if (this.bookingObj.groupNames) {
      this.bookingObj.groups = this.utilityFunctions.createGroupArray(this.bookingObj.groupNames);
    }
    if (this.validateMandatoryFields()) {
      if (this.showAddMemberFields && this.memberAddedSuccesfullyMsg === '') {
        memberData = {
          membershipId: this.bookingObj.membershipId,
          firstName: this.bookingObj.firstName,
          lastName: this.bookingObj.lastName,
          emailId: this.bookingObj.emailId,
          contactNumber: this.bookingObj.contactNumber,
          type: this.bookingObj.type,
          countryCode: this.bookingObj.countryCode,
          addressLine1: this.bookingObj.addressLine1,
          addressLine2: this.bookingObj.addressLine2,
          note: this.bookingObj.note,
          groups: this.bookingObj.groups
        }
      }

      if (this.bookButtonText == CONSTANT_MESSAGES.FORCEBOOK_BUTTON_TEXT) {
        this.bookingObj.isForcedBooking = true;
      }
      let requestObject = {
        membershipId: this.bookingObj.membershipId,
        facilityId: this.facility._id,
        vendorId: this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN ? this.vendor._id : this.vendor.vendorId,
        startTime: this.eventData.startTimeNew.toISOString(),
        endTime: this.eventData.endTimeNew.toISOString(),
        attendees: this.bookingObj.attendees,
        'hours': this.bookingObj.hours,
        'title': this.facility.name,
        'unitName': this.facility.isCourtSelection ? this.selectedUnit : '',
        'isWalkInBooking': true,
        isForcedBooking: this.bookingObj.isForcedBooking,
        bookingSlots: this.bookingObj.bookingSlots,
        bookingNote: this.bookingObj.bookingVendorNote,
      };
      if (this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
        requestObject.vendorId = this.vendor._id;
      } else {
        requestObject.vendorId = this.vendor.vendorId;
      }
      let actualReqObj;
      let checkInTime = this.calculateCheckInTime(requestObject)
      if (checkInTime) {
        requestObject['checkInTime'] = checkInTime;
      }
      if (memberData && this.memberAddedSuccesfullyMsg == '') {
        actualReqObj = {
          vendorId: this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN ? this.vendor._id : this.vendor.vendorId,
          bookingData: requestObject ? requestObject : {},
          memberData: memberData ? memberData : {}
        }


        if (this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
          actualReqObj.vendorId = this.vendor._id;
        } else {
          actualReqObj.vendorId = this.vendor.vendorId;
        }


        this.bookingBasedOnMemberShipId(actualReqObj, popUpObj, msgPopUpObj);
      } else {
        if (this.memberAddedSuccesfullyMsg !== '') {
          requestObject['_id'] = this.userId;
        } else {
          requestObject['_id'] = this.bookingObj.userId;
        }
        if (this.facility.isWeeklyRepeatBooking) {
          requestObject['userId'] = this.bookingObj.userId;
        }
        actualReqObj = requestObject;
        this.bookingBasedOnMemberShipId(actualReqObj, popUpObj, msgPopUpObj);
      }

    }
  }

  /*Booking Request */
  bookingBasedOnMemberShipId(reqObject, popUpObj, msgPopUpObj) {
    let reqObjForRepeat;
    if (reqObject.memberData && this.memberAddedSuccesfullyMsg === '') {
      this.addMemberWithBooking(reqObject, popUpObj, msgPopUpObj);
    } else {
      if (!this.facility.isWeeklyRepeatBooking) {
        this.bookingForMember(reqObject, msgPopUpObj);
      } else {
        reqObjForRepeat = {
          repeatCount: this.repeatCount,
          isAvailabilityRequest: true,
          timezoneOffset: this.vendor.timezoneOffset,
          vendorId: ''
        }
        if (this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
          reqObjForRepeat.vendorId = this.vendor._id;
        } else {
          reqObjForRepeat.vendorId = this.vendor.vendorId;
        }
        reqObjForRepeat.repeatCount = this.repeatCount;
        reqObjForRepeat['bookingData'] = reqObject;
        this.repeatedBookingForMember(reqObjForRepeat);
      }

    }
  }

  bookingForMember(reqObject, popUpObj) {
    if (this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
      reqObject['vendorId'] = this.vendor._id;
    } else {
      reqObject['vendorId'] = this.vendor.vendorId;
    }
    let userId = reqObject._id;
    this.calendarService.bookingForMember(reqObject).then((result: any) => {
      if (result.canBeForceBooked && this.isShowAllowForceBooking) {
        this.isShowCanBeForceBookedMessage = true;
        this.bookButtonText = CONSTANT_MESSAGES.FORCEBOOK_BUTTON_TEXT;;
        this.loaderEvent.fire(true);
      } else {
        this.hideChildModal();
        this.resetAll(false);
        this.loaderEvent.fire(true);
        this.bookingPopupMessage = result.message;
        this.confirmationBookingResult = result.status == 'SUCCESS' ? this.generateInvoice(result.bookingData, userId, reqObject.bookingSlots) : undefined;
        this.bookingConfirmation = result.status == 'SUCCESS' ? true : false;
        popUpObj.showChildModal();
      }
    });
  }

  addMemberWithBooking(reqObject, popUpObj, msgPopupObj) {
    if (this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
      reqObject['vendorId'] = this.vendor._id;
    } else {
      reqObject['vendorId'] = this.vendor.vendorId;
    }
    if (!this.facility.isWeeklyRepeatBooking) {
      reqObject['repeatCount'] = 1;
    } else {
      reqObject.isAvailabilityRequest = true;
      reqObject['repeatCount'] = this.repeatCount;
    }
    reqObject['timezoneOffset'] = this.vendor.timezoneOffset;
    this.loaderEvent.fire(false);
    this.requestForRepeat = reqObject;
    this.calendarService.addMemberWithBooking(reqObject).then((result: any) => {
      if (!this.facility.isWeeklyRepeatBooking) {
        if (result.canBeForceBooked && this.isShowAllowForceBooking) {
          this.isShowCanBeForceBookedMessage = true;
          this.bookButtonText = CONSTANT_MESSAGES.FORCEBOOK_BUTTON_TEXT;
          this.userId = result.userId;
          this.loaderEvent.fire(true);
          if (result.memberMessage) {
            this.memberAddedSuccesfullyMsg = result.memberMessage;
          } else {
            this.memberAddedSuccesfullyMsg = '';
          }
        } else if (result.status === CONSTANT_VALUES.RESPONSE_ERROR) {
          this.popUpMessage = result.message;
          this.loaderEvent.fire(true);
          this.hideChildModal();
          popUpObj.showChildModal();
        } else {
          if (result.data[0] && result.data[0].isFailed) {
            this.bookingPopupMessage = result.message ? result.message : result.memberMessage + result.data[0].bookingMessage;
            this.bookingConfirmation = false;
          } else {
            this.bookingPopupMessage = result.message ? result.message : result.memberMessage + result.data.bookingLogs[0].bookingMessage;
            this.confirmationBookingResult = result.status == 'SUCCESS' ? this.generateInvoice(result.data.bookingLogs[0].jsonData, result.data.bookingLogs[0].userData._id, reqObject.bookingSlots) : undefined;
            this.bookingConfirmation = true;
          }
          this.hideChildModal();
          this.resetAll(false);
          this.loaderEvent.fire(true);
          this.hideChildModal();
          msgPopupObj.showChildModal();
        }
      } else {
        this.memberAddedSuccesfullyMsg = result.message;
        if (result.status == "ERROR") {
          this.loaderEvent.fire(true);
        } else {
          this.memberAddedSuccesfullyMsg = result.memberMessage;
          delete this.requestForRepeat.memberData;
          this.requestForRepeat.bookingData.userId = result.userId;
          this.requestForRepeat.bookingData._id = result.userId;
          this.bookingObj.userId = result.userId;
          this.showAvailableSlots(result);
        }
      }
      //this.handleRepeatBookingResponse(result, popUpObj);
    });
  }

  /**
   * Set contact number and email id on the popup based on first name
   *
   * @param {any} firstName
   *
   * @memberof GuestBookingComponent
   */
  setDetails(userId) {
    if (userId) {
      let obj = _.find(this.memberList, { userId: userId });
      this.bookingObj.firstName = obj.firstName;
      this.bookingObj.emailId = obj['emailId'];
      this.bookingObj.contactNumber = (obj['countryCode'] ? obj['countryCode'] : '').concat(' ' + obj['contactNumber']);
      this.bookingObj.userId = obj['userId'];
      this.bookingObj.membershipId = obj['membershipId'];
      if (!(this.bookingObj.firstName + '').trim()) {
        this.validate.firstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.flag = false;
      } else {
        this.validate.firstName = '';
      }
    } else {
      this.validate.firstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.bookingObj.firstName = '';
    }

  }

  /**
   * Get member list according to membership id.
   *
   * @param {any} membershipId
   * @param {any} popUpObj
   *
   * @memberof GuestBookingComponent
   */
  getMemberList(membershipId, popUpObj) {
    if (!(this.memberIdOrFirstName + '').trim()) {
      this.validate.memberIdOrFirstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
      this.resetFields();
    } else {
      this.validate.memberIdOrFirstName = '';
      this.getDataByMemberShipId(membershipId, popUpObj);
    }
  }

  getDataByMemberShipId(membershipId, popUpObj) {
    this.loaderEvent.fire(false);
    let requestObject: any = {
      membershipId: membershipId
    };
    // API call for get member list according to membership id
    if (this._appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
      requestObject.vendorId = this.vendor._id;
    } else {
      requestObject.vendorId = this.vendor.vendorId;
    }

    this.calendarService.getMembersByMembershipId(requestObject).then((result: any) => {
      if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
        this.resetFields();
        this.memberList = result.vendorData[0]['members'];
        this.showAddMemberMessage = false;
        this.showAddMemberFields = false;
        this.isContactDisable = true;
        this.isEmailIdDisable = true;
        this.isopen1 = this.memberList.length > 0 ? true : false;
      } else {
        if (result.message == "No such record found.") {
          this.showAddMemberMessage = true;
        } else {
          this.hideChildModal();
          this.memberList = [];
          this.popUpMessage = result.message;
          popUpObj.showChildModal();
        }
      }
      if (this.memberList.length > 0) {
        this.isEmailIdDisable = false;
      } else {
        this.resetFields();
      }
      this.loaderEvent.fire(true);
      return (!this.isEmailIdDisable);
    });
  }

  showParentPopup() {
    this.showChildModal();
  }

  testCategory() {
    if (_.indexOf(CONSTANT_VALUES.AMENITIES, this.facility.category) >= 0) {
      this.showHour = true;
    } else {
      this.showHour = false;
    }
  }

  /**
   * Validate booking time
   *
   * @param {any} popUpObj
   *
   * @memberof GuestBookingComponent
   */
  bookingTimeValidation(popUpObj, msgPopUpObj) {
    if (this.validateMandatoryFields()) {
      if (this.checkMaxNumberOfPeopleWeekend(popUpObj)) {
        if (this.facility['isAttendeeCountRequired'] &&
          this.facility['maxNumberOfPeopleWeekday'] &&
          this.facility['maxNumberOfPeopleWeekday'] < parseInt(this.bookingObj.attendees)) {
          this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
          this.popUpMessage = CONSTANT_MESSAGES.NUMPER_OF_PEOPLE_ERROR;
          this.hideChildModal();
          popUpObj.showChildModal();
        } else {
          this.isShowCanBeForceBookedMessage = false;
          //this.bookButtonText = CONSTANT_MESSAGES.BOOK_BUTTON_TEXT;
          this.bookingRequest(popUpObj, msgPopUpObj);
        }
      }
    } else {
      this.allSlotsUnavailable = true;
    }
  }

  /**
   * Validate maximum number of attendee
   *
   * @param {any} popUpObj
   * @returns
   *
   * @memberof GuestBookingComponent
   */
  checkMaxNumberOfPeopleWeekend(popUpObj) {
    if (this.facility['isAttendeeCountRequired'] &&
      (this.eventData.startTimeNew.days() === 6 || this.eventData.startTimeNew.days() === 0)) {
      if (this.facility['maxNumberOfPeopleWeekend'] &&
        (this.facility['maxNumberOfPeopleWeekend'] < parseInt(this.bookingObj.attendees))) {
        this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.popUpMessage = CONSTANT_MESSAGES.NUMPER_OF_PEOPLE_ERROR;
        this.hideChildModal();
        popUpObj.showChildModal();
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  /**
   * Reset fields
   *
   *
   * @memberof GuestBookingComponent
   */
  resetData() {
    this.bookingObj.contactNumber = '';
    this.bookingObj.emailId = '';
    this.bookingObj.firstName = '';
    this.bookingObj.type = '';
    this.bookingObj.lastName = '';
    this.bookingObj.membershipId = '';
    this.isEmailIdDisable = true;
    this.memberList = [];
    this.errMessage = '';
  }

  resetFields() {
    this.bookingObj.emailId = '';
    this.bookingObj.contactNumber = '';
    this.bookingObj.firstName = '';
    this.bookingObj.userId = '';
    this.bookingObj.type = '';
    this.bookingObj.lastName = '';
    this.bookingObj.membershipId = '';
    this.isEmailIdDisable = true;
    this.errMessage = '';
  }

  /* No of people */
  decreaseNoOfPeople(currentAttendees) {
    if (this.validationForMandatoryFields('attendees', '', true)) {
      if (currentAttendees !== "1") {
        currentAttendees--;
        this.bookingObj.attendees = currentAttendees.toString();
        this.enableIcon();
      }
    }
  }

  increaseNoOfPeople(currentAttendees) {
    let timeZoneSelectedDate = moment(this.eventData['startTimeNew']).utcOffset(this.timezoneOffset);
    let maxNoOfPeopleAllowed;
    let attendees;
    if (this.facility['isAttendeeCountRequired']) {
      attendees = parseInt(this.bookingObj.attendees) + 1;
      if (timeZoneSelectedDate.day() == 0 || timeZoneSelectedDate.day() == 6) {
        maxNoOfPeopleAllowed = this.facility['maxNumberOfPeopleWeekend'];
        if (attendees == this.facility['maxNumberOfPeopleWeekend']) {
          this.disableIncreaseIcon = true;
          this.nocursorplus = 'no-cursor';
        }
      } else {
        maxNoOfPeopleAllowed = this.facility['maxNumberOfPeopleWeekday'];
        if (attendees == this.facility['maxNumberOfPeopleWeekday']) {
          this.disableIncreaseIcon = true;
          this.nocursorplus = 'no-cursor';
        }
      }
      if (currentAttendees < maxNoOfPeopleAllowed) {
        currentAttendees++;
        this.bookingObj.attendees = currentAttendees.toString();
      }
    } else {
      currentAttendees++;
      this.bookingObj.attendees = currentAttendees.toString();
    }
    this.validate.attendees = this.bookingObj.attendees ? '' : 'required'
    //disable decrease icon
    if (parseInt(this.bookingObj.attendees) <= 1) {
      this.disableDecreaseIcon = true;
      this.nocursor = 'no-cursor';
    } else {
      this.disableDecreaseIcon = false;
      this.nocursor = '';
    }
    this.validate.attendees = this.bookingObj.attendees && parseInt(this.bookingObj.attendees) < 1 ? 'required' : '';
  }

  showNoOfPeopleErrorMsg() {
    if (!parseInt(this.bookingObj.attendees)) {
      this.noOfPeopleErrorMsg = CONSTANT_MESSAGES.ENTER_VALID_NO_OF_PEOPLE_ERROR_MSG;
    }
    else if (this.facility['isAttendeeCountRequired']) {
      let timeZoneSelectedDate = moment(this.eventData['startTimeNew']).utcOffset(this.timezoneOffset);
      if (timeZoneSelectedDate.day() == 0 || timeZoneSelectedDate.day() == 6) {
        this.noOfPeopleErrorMsg = CONSTANT_MESSAGES.MAX_NO_OF_PEOPLE_ERROR + this.facility['maxNumberOfPeopleWeekend'];
        this.disableIncreaseIcon = true;
        this.nocursorplus = 'no-cursor';
      } else {
        this.noOfPeopleErrorMsg = CONSTANT_MESSAGES.MAX_NO_OF_PEOPLE_ERROR + this.facility['maxNumberOfPeopleWeekday'];
        this.disableIncreaseIcon = true;
        this.nocursorplus = 'no-cursor';
      }
    }
    else {
      this.noOfPeopleErrorMsg = '';
      this.nocursorplus = '';
    }
  }

  checkAttendeeCount() {
    let timeZoneSelectedDate = moment(this.eventData['startTimeNew']).utcOffset(this.timezoneOffset);
    if (this.facility['isAttendeeCountRequired']) {
      if (this.bookingObj.attendees && parseInt(this.bookingObj.attendees) >= 1) {
        if (timeZoneSelectedDate.day() == 0 || timeZoneSelectedDate.day() == 6) {
          return this.bookingObj.attendees <= this.facility['maxNumberOfPeopleWeekend'] ? false : true;
        } else {
          return this.bookingObj.attendees <= this.facility['maxNumberOfPeopleWeekday'] ? false : true;
        }
      }
    } else {
      return false;
    }
  }

  bookingHourValues() {
    let activityStartTime;
    let activityEndTime;
    let currentDate = moment().utcOffset(this.timezoneOffset);
    let currentHour = currentDate.hour().toString();
    let currentMinute = currentDate.minute().toString();
    currentDate.set({ 'hours': 0, 'minutes': 0, 'second': 0 });
    let date = this.eventData.startTimeNew.date(), month = this.eventData.startTimeNew.month(), year = this.eventData.startTimeNew.year();
    let calendarDate = moment().utcOffset(this.timezoneOffset).set({ 'hours': 0, 'minutes': 0, 'second': 0, 'date': date, month: month, year: year });
    if (this.facility) {
      this.ActivityStartTimeHoursList = [];
      if (currentDate.isSame(calendarDate)) {
        activityEndTime = this.facility.timings.closeTime ? this.facility.timings.closeTime.replace(/:00:00/g, '') : '';
        currentHour = ('0' + currentHour).slice(-2);
        let startHours = parseInt(currentMinute) < 45 ? parseInt(currentHour) : parseInt(currentHour) + 1;
        let endHours = activityEndTime.split(':')[0];
        let endMinutes = activityEndTime.split(':')[1];
        let totalMinute = parseInt(endHours) * 60 + parseInt(endMinutes);
        totalMinute = totalMinute == 1439 ? 1440 : totalMinute;
        let remainingMinutes = totalMinute - parseInt(this.facility.slotDuration);
        endHours = Math.floor(remainingMinutes / 60);
        let endMinute = remainingMinutes % 60;
        while (startHours <= endHours) {
          this.ActivityStartTimeHoursList.push(('0' + startHours).slice(-2));
          startHours++;
        }
        _.remove(this.ActivityStartTimeHoursList, function (rec: any) {
          return rec == 24;
        });
        _.remove(this.minutes_value, function (rec: any) {
          if (parseInt(currentMinute) > parseInt(rec) && parseInt(currentMinute) < 45 && endMinute > 45) {
            return rec;
          }
        });
      } else {
        activityStartTime = this.facility.timings.openTime ? this.facility.timings.openTime.replace(/:00:00/g, '') : '';
        activityEndTime = this.facility.timings.closeTime ? this.facility.timings.closeTime.replace(/:00:00/g, '') : '';
        let startHours = activityStartTime.split(':')[0];
        let endHours = activityEndTime.split(':')[0];
        let endMinutes = activityEndTime.split(':')[1];
        let totalMinute = parseInt(endHours) * 60 + parseInt(endMinutes);
        totalMinute = totalMinute == 1439 ? 1440 : totalMinute;
        let remainingMinutes = totalMinute - parseInt(this.facility.slotDuration);
        endHours = Math.floor(remainingMinutes / 60);
        while (startHours <= endHours) {
          this.ActivityStartTimeHoursList.push(('0' + startHours).slice(-2));
          startHours++;
        }
        _.remove(this.ActivityStartTimeHoursList, function (rec: any) {
          return rec == 24;
        });
      }
      if (parseInt(this.bookingStart_hours) > this.ActivityStartTimeHoursList[this.ActivityStartTimeHoursList.length - 1]) {
        this.ActivityStartTimeHoursList = [];
        this.minutes_value = [];
      }
    } else {
    }
  }

  showSlotTime() {
    let bookingTimeLock = this.bookingStartLockOn ? this.bookingStartLockOn.split(':') : '';
    let hour_lock = bookingTimeLock ? bookingTimeLock[0] : '';
    let minute_lock = bookingTimeLock ? bookingTimeLock[1] : '';

    if (this.facility.isSlotsLocked) {
      this.eventData.startTimeNew.set({ 'hour': parseInt(hour_lock), 'minute': parseInt(minute_lock) });
    } else {
      this.eventData.startTimeNew.set({ 'hour': parseInt(this.bookingStart_hours), 'minute': this.bookingStart_minutes });
    }
    this.eventStartTime = this.eventData.startTimeNew.format('HH:mm');
    let slotDuration = parseInt(this.facility.slotDuration + '') ? parseInt(this.facility.slotDuration) : CONSTANT_VALUES.AMENETIES_SLOT;
    slotDuration = slotDuration == 1439 ? 1440 : slotDuration;
    let flag = true;
    if (!this.facility.isSlotsLocked) {
      flag = this.setBookingEndTime(this.bookingStart_hours, this.bookingStart_minutes, slotDuration, this.bookingObj.bookingSlots);
    } else {
      flag = this.setBookingEndTime(hour_lock, minute_lock, slotDuration, this.bookingObj.bookingSlots);
    }
    this.setTime(flag);
  }

  calculateBookingEndTime() {
    let tempActivityOpenTime;
    let hour_lock, minute_lock;
    if (this.bookingStartLockOn.length >= 1) {
      let bookingTimeLock = this.bookingStartLockOn.split(':');
      hour_lock = bookingTimeLock[0];
      minute_lock = bookingTimeLock[1];
    }
    tempActivityOpenTime = this.facility.timings.openTime.split(':');
    let flag = true;
    // Calculating start time
    if (!this.facility.isSlotsLocked) {
      if ((parseInt(this.bookingStart_minutes) < parseInt(tempActivityOpenTime[1])) && (parseInt(this.bookingStart_hours) <= parseInt(tempActivityOpenTime[0]))) {
        this.errMessage = CONSTANT_MESSAGES.BOOKING_WITHIN_ACTIVITY_TIMINGS_ERROR;
        this.endTime = ''
        return;
      } else {
        this.eventData.startTimeNew.set({ 'hour': parseInt(this.bookingStart_hours), 'minute': this.bookingStart_minutes });
      }
    } else {
      if ((parseInt(minute_lock) < parseInt(tempActivityOpenTime[1])) && (parseInt(hour_lock) <= parseInt(tempActivityOpenTime[0]))) {
        this.errMessage = CONSTANT_MESSAGES.BOOKING_WITHIN_ACTIVITY_TIMINGS_ERROR;
        this.endTime = ''
        return;
      } else {
        this.eventData.startTimeNew.set({ 'hour': parseInt(hour_lock), 'minute': parseInt(minute_lock) });
      }
    }
    this.endTime = '';
    let slotDuration = parseInt(this.facility.slotDuration + '') ? parseInt(this.facility.slotDuration) : CONSTANT_VALUES.AMENETIES_SLOT;
    slotDuration = slotDuration == 1439 ? 1440 : slotDuration;
    if (!this.facility.isSlotsLocked) {
      flag = this.setBookingEndTime(this.bookingStart_hours, this.bookingStart_minutes, slotDuration, this.bookingObj.bookingSlots);
    } else {
      flag = this.setBookingEndTime(hour_lock, minute_lock, slotDuration, this.bookingObj.bookingSlots);

    }
    this.setTime(flag);
  }

  decreaseNoOfBooking() {
    let bookingSlot;
    bookingSlot = parseInt(this.bookingObj.bookingSlots);
    if (bookingSlot && bookingSlot >= 1) {
      if (bookingSlot !== 1) {
        bookingSlot = bookingSlot - 1;
        this.bookingObj.bookingSlots = bookingSlot.toString();
        this.calculateBookingEndTime();
      }
    }
    if (this.bookingObj.bookingSlots === "1") {
      this.disableDecreaseIconOfSlots = true;
      this.noCursorSlots = 'no-cursor';
    } else {
      this.disableDecreaseIconOfSlots = false;
      this.noCursorSlots = '';
    }
  }

  increaseNoOfBooking() {
    let bookingSlot;
    bookingSlot = this.bookingObj.bookingSlots ? parseInt(this.bookingObj.bookingSlots) : 0;
    bookingSlot = bookingSlot + 1;
    this.bookingObj.bookingSlots = bookingSlot.toString();
    this.validate.bookingSlots = this.bookingObj.bookingSlots ? '' : 'required'
    this.calculateBookingEndTime();
    this.handleBookingIcons();
  }

  enableIcon() {
    this.handleIcon();
    let attendees;
    let maxNoOfPeopleAllowed;
    let timeZoneSelectedDate = moment(this.eventData['startTimeNew']).utcOffset(this.timezoneOffset);
    if (this.facility['isAttendeeCountRequired']) {
      if (this.bookingObj.attendees) {
        attendees = this.bookingObj.attendees;
        if (timeZoneSelectedDate.day() == 0 || timeZoneSelectedDate.day() == 6) {
          maxNoOfPeopleAllowed = this.facility['maxNumberOfPeopleWeekend'];
          if (attendees == maxNoOfPeopleAllowed) {
            this.disableIncreaseIcon = true;
            this.nocursorplus = 'no-cursor';
          }
        } else {
          maxNoOfPeopleAllowed = this.facility['maxNumberOfPeopleWeekday'];
          if (attendees == maxNoOfPeopleAllowed) {
            this.disableIncreaseIcon = true;
            this.nocursorplus = 'no-cursor';
          }
        }
      }
    }
  }

  calculateCheckInTime(reqObj) {
    let currentDay = moment().utcOffset(this.timezoneOffset);
    let currentTime = currentDay.toISOString();
    if (currentDay.isBetween(moment(reqObj.startTime).utcOffset(this.timezoneOffset), moment(reqObj.endTime).utcOffset(this.timezoneOffset))) {
      return currentTime;
    } else {
      return '';
    }
  }

  setMinVal() {
    if (parseInt((this.bookingObj.attendees + '').trim()) <= 0) {
      this.validate.attendees = 'required';
      this.disableDecreaseIcon = true;
    }
  }

  setMinValSlots() {
    if (parseInt((this.bookingObj.bookingSlots + '').trim()) <= 0) {
    } else {
    }
  }

  handleIcon() {
    if (this.bookingObj.attendees) {
      if (parseInt(this.bookingObj.attendees) <= 1) {
        this.disableDecreaseIcon = true;
        this.nocursor = 'no-cursor';
        this.nocursorplus = '';
        this.disableIncreaseIcon = false;
      } else if (parseInt(this.bookingObj.attendees) > 1 && this.checkAttendeeCount()) {
        this.disableDecreaseIcon = false;
        this.nocursor = '';
        this.nocursorplus = 'no-cursor';
        this.disableIncreaseIcon = true;
      } else {
        this.disableDecreaseIcon = false;
        this.nocursor = '';
        this.nocursorplus = '';
        this.disableIncreaseIcon = false;
      }
    } else {
      if (parseInt(this.bookingObj.attendees) <= 0) {
        this.disableDecreaseIcon = true;
        this.nocursor = 'no-cursor';
        this.nocursorplus = '';
        this.disableIncreaseIcon = false;
      } else {
        this.disableDecreaseIcon = true;
        this.nocursor = 'no-cursor';
        this.nocursorplus = 'no-cursor';
        this.disableIncreaseIcon = true;
      }
    }
  }

  handleBookingIcons() {
    if (this.bookingObj.bookingSlots) {
      if (parseInt(this.bookingObj.bookingSlots) == 1) {
        this.disableDecreaseIconOfSlots = true;
        this.noCursorSlots = 'no-cursor';
      } else if (parseInt(this.bookingObj.bookingSlots) > 1 && this.checkAttendeeCount()) {
        this.disableDecreaseIconOfSlots = false;
        this.noCursorSlots = '';
      } else {
        this.disableDecreaseIconOfSlots = false;
        this.noCursorSlots = '';
      }
    } else {
      if (parseInt(this.bookingObj.bookingSlots) == 0) {
        this.disableDecreaseIconOfSlots = true;
        this.noCursorSlots = 'no-cursor';
      } else {
        this.disableDecreaseIconOfSlots = true;
        this.noCursorSlots = 'no-cursor';
      }
    }
  }

  showPreviousVal() {
    this.bookingStartLockOn = this.utilityFunctions.showPreviousVal(this.facility.activitySlots, this.bookingStartLockOn);
    this.calculateEndTimeOnLockTime();
  }

  showNextSlot() {
    this.bookingStartLockOn = this.utilityFunctions.showNextSlot(this.facility.activitySlots, this.bookingStartLockOn);
    this.calculateEndTimeOnLockTime();
  }

  calculateBookingSlot() {
    let slot = (('0' + this.eventData.startTimeNew.hours()).slice(-2) + ':' + ('0' + this.eventData.startTimeNew.minutes()).slice(-2)).toString();
    let i = -1;
    let currentDate = moment().utcOffset(this.timezoneOffset);
    let currentHour = currentDate.hour();
    const date = this.eventData.startTimeNew.date(), month = this.eventData.startTimeNew.month(), year = this.eventData.startTimeNew.year(), hour = this.eventData.startTimeNew.hour(), minute = this.eventData.startTimeNew.minute(), second = this.eventData.startTimeNew.second();
    let bookingDate = moment().utcOffset(this.timezoneOffset).set({ 'date': date, month: month, year: year });
    let currentTime = currentHour;
    do {
      i++;
    } while (this.facility.activitySlots[i] <= slot);
    let slotDuration1;
    if (i == this.facility.activitySlots.length - 1) {
      slotDuration1 = this.facility.activitySlots[i] ? parseInt((this.facility.activitySlots[i]).slice(0, 2)) : 0;
    } else {
      slotDuration1 = this.facility.activitySlots[i - 1] ? parseInt((this.facility.activitySlots[i - 1]).slice(0, 2)) : 0;
    }
    let slotDuration0 = this.facility.activitySlots[i - 1] ? parseInt((this.facility.activitySlots[i - 1]).slice(0, 2)) : 0;
    if (currentDate.isSame(bookingDate) && (slotDuration0 <= currentTime && currentTime < slotDuration1)) {
      this.bookingStartLockOn = this.facility.activitySlots[i];
    } else {
      this.bookingStartLockOn = this.facility.activitySlots[i - 1];
    }
    this.blockPrev = this.bookingStartLockOn == this.facility.activitySlots[0] ? false : true;
    this.blockNext = this.bookingStartLockOn == this.facility.activitySlots[this.facility.activitySlots.length - 1] ? false : true;
  }

  calculateEndTimeOnLockTime() {
    this.blockPrev = this.bookingStartLockOn == this.facility.activitySlots[0] ? false : true;
    this.blockNext = this.bookingStartLockOn == this.facility.activitySlots[this.facility.activitySlots.length - 1] ? false : true;
    this.calculateBookingEndTime();
  }

  populateAddMemberFields() {
    this.showAddMemberFields = true;
    this.isContactDisable = false;
    this.isEmailIdDisable = false;
    this.showAddMemberMessage = false;
    this.bookingObj.membershipId = this.memberIdOrFirstName;
  }

  callRefreshPage(e) {
    this.hideChildModal();
    this.refreshPage.emit(true);
  }
  callRefreshPageAfterInvoice() {
    this.refreshPage.emit(true);
  }

  repeatBookingOnContinue(bookingLog) {
    this.statusChecked = false;
    this.loaderEvent.fire(false);
    let that = this;
    this.requestForRepeat.isAvailabilityRequest = false;
    if (this.isShowAllowForceBooking && this.isShowCanBeForceBookedMessage) {
      this.requestForRepeat.bookingData.isForcedBooking = true;
    }
    this.loaderEvent.fire(false);
    this.calendarService.repeatedBookingForMember(this.requestForRepeat).then((result: any) => {
      this.resetAll(false);
      if (that.requestForRepeat.repeatCount == 1) {
        this.confirmationBookingResult = result.status == 'SUCCESS' ? this.generateInvoice(result.data.bookingLogs[0].jsonData, result.data.bookingLogs[0].userData._id, that.requestForRepeat.bookingData.bookingSlots) : undefined;
      }
      this.showAvailableSlots(result, true);
      this.hideChildModal();
      bookingLog.showChildModal(this.statusOFBookings, that.timezoneOffset);
      this.resetAll(false);
      this.loaderEvent.fire(true);
    });
  }


  sendBookingToServer(reqObject) {
    if (reqObject) {
      this.loaderEvent.fire(false);
      this.calendarService.repeatedBookingForMember(reqObject).then((result: any) => {
        this.showAvailableSlots(result);
      });
    } else {
    }
  }

  repeatedBookingForMember(reqObject) {
    reqObject.bookingData.isForcedBooking = false;
    this.requestForRepeat = reqObject;
    this.statusChecked = true;
    this.sendBookingToServer(reqObject);
  }

  handleRepeatBookingResponse(result, popUpObj) {
    let datesForSuccess = [];
    let datesForFailed = [];
    let repeatFailedBookingsDate;
    let repeatSuccessBookingsDate;
    let failedResultsStartDate = [];
    let succeddedResultStartDate = [];
    let successFlag = false;
    let failedFlag = false;
    //not completed
    if (result.data.wasNotAvailabilityRequest) {
      let unitName;
      result.data.bookingLogs.forEach((r) => {
        if (r.isSucceeded) {
          let date = moment(r.startTime).utcOffset(this.timezoneOffset).format('LL');
          let startTime = moment(r.startTime).utcOffset(this.timezoneOffset).format('LT')
          let endTime = moment(r.endTime).utcOffset(this.timezoneOffset).format('LT');
          if (r.unitName) {
            unitName = r.unitName;
          }
          datesForSuccess.push(date + ' from ' + startTime + ' to ' + endTime + ' for ' + unitName);
          successFlag = true;
        } else if (r.isFailed) {
          let date = moment(r.startTime).utcOffset(this.timezoneOffset).format('LL');
          let startTime = moment(r.startTime).utcOffset(this.timezoneOffset).format('LT')
          let endTime = moment(r.endTime).utcOffset(this.timezoneOffset).format('LT');
          if (r.unitName) {
            unitName = r.unitName;
          }
          datesForFailed.push(date + ' from ' + startTime + ' to ' + endTime + ' for ' + unitName);
          failedFlag = true
        }
      });
      this.loaderEvent.fire(true);
      this.hideChildModal();
      this.resetAll(false);
      let memberAddedSuccessMsg;
      if (result.memberMessage) {
        memberAddedSuccessMsg = result.memberMessage;
      }

      let message;
      if (successFlag) {
        message = memberAddedSuccessMsg + ' Your bookings have been confirmed for ' + datesForSuccess.join();
      }
      if (failedFlag) {
        message = message + ' Your bookings have not been confirmed for ' + datesForFailed.join();
      }
      this.bookingPopupMessage = message;
      popUpObj.showChildModal();
    } else {
      if (!result.data.completeSuccess) {
        result.data.bookingLogs.forEach((r) => {
          if (r.canBeForceBooked && this.isShowAllowForceBooking) {
            this.loaderEvent.fire(true);
            this.isShowCanBeForceBookedMessage = true;
            this.bookButtonText = CONSTANT_MESSAGES.FORCEBOOK_BUTTON_TEXT;
          } else {
            this.loaderEvent.fire(true);
            if (r.isFailed) {
              repeatFailedBookingsDate = moment(r.startTime).utcOffset(this.timezoneOffset).format('LL');
              failedResultsStartDate.push(repeatFailedBookingsDate);
            } else {
              repeatSuccessBookingsDate = moment(r.startTime).utcOffset(this.timezoneOffset).format('LL');
              succeddedResultStartDate.push(repeatSuccessBookingsDate);
            }
          }
        });
        this.isShowContinueBookingMessage = true;
        this.continueBookingMessage = 'You cannot do booking for ' + failedResultsStartDate.join() + '. Do you want to continue booking for ' + succeddedResultStartDate.join();
        this.loaderEvent.fire(true);
      }
      //completed
      else {
        let unitName;
        result.data.bookingLogs.forEach((r) => {
          if (r.isSucceeded) {
            let date = moment(r.startTime).utcOffset(this.timezoneOffset).format('LL');
            let startTime = moment(r.startTime).utcOffset(this.timezoneOffset).format('LT')
            let endTime = moment(r.endTime).utcOffset(this.timezoneOffset).format('LT');
            if (r.unitName) {
              unitName = r.unitName;
            }
            datesForSuccess.push(date + ' from ' + startTime + ' to ' + endTime + ' for ' + unitName);
            successFlag = true;
          } else if (r.isFailed) {
            let date = moment(r.startTime).utcOffset(this.timezoneOffset).format('LL');
            let startTime = moment(r.startTime).utcOffset(this.timezoneOffset).format('LT')
            let endTime = moment(r.endTime).utcOffset(this.timezoneOffset).format('LT');
            if (r.unitName) {
              unitName = r.unitName;
            }
            datesForFailed.push(date + ' from ' + startTime + ' to ' + endTime + ' for ' + unitName);
            failedFlag = true
          }
        });
        this.loaderEvent.fire(true);
        this.hideChildModal();
        this.resetAll(false);
        let memberAddedSuccessMsg;
        if (result.memberMessage) {
          memberAddedSuccessMsg = result.memberMessage;
        }

        let message;
        if (successFlag) {
          message = memberAddedSuccessMsg + ' Your bookings have been confirmed for ' + datesForSuccess.join();
        }
        if (failedFlag) {
          message = message + ' Your bookings have not been confirmed for ' + datesForFailed.join();
        }
        this.bookingPopupMessage = message;
        popUpObj.showChildModal();
      }
    }

  }

  showAvailableSlots(result, setForceFlag?) {
    const flag = setForceFlag ? true : false;
    this.allSlotsUnavailable = true;
    let unitName;
    const that = this;
    let obj;
    this.monthWiseBlock = [];
    let monthWiseBlock = {};
    this.statusOFBookings = [];
    let showFlag = '';
    if (result.data.bookingLogs) {
      result.data.bookingLogs.forEach((r) => {
        if (r.canBeForceBooked && this.isShowAllowForceBooking) {
          this.isShowCanBeForceBookedMessage = true;
          this.bookButtonText = CONSTANT_MESSAGES.FORCEBOOK_BUTTON_TEXT;
          that.requestForRepeat.bookingData.isForcedBooking = flag ? true : false;
        } else {
          that.requestForRepeat.bookingData.isForcedBooking = false;
        }
        let date = moment(r.startTime).utcOffset(that.timezoneOffset).format('LL');
        let startTime = moment(r.startTime).utcOffset(that.timezoneOffset).format('LT');
        let endTime = moment(r.endTime).utcOffset(that.timezoneOffset).format('LT');
        let month = moment(r.startTime).utcOffset(that.timezoneOffset).format('MMMM YYYY');
        if (that.facility.isAllowForceBooking) {
          showFlag = r.canBeForceBooked ? 'orange' : r.isSucceeded ? 'green' : 'red';
        } else {
          showFlag = r.isSucceeded ? 'green' : 'red';
        }
        if (monthWiseBlock[month]) {
          monthWiseBlock[month].push({ date: moment(r.startTime).utcOffset(that.timezoneOffset).dates(), status: r.isSucceeded ? true : false, canBeForceBooked: r.canBeForceBooked, showFlag: showFlag });
        } else {
          monthWiseBlock[month] = [];
          monthWiseBlock[month].push({ date: moment(r.startTime).utcOffset(that.timezoneOffset).dates(), status: r.isSucceeded ? true : false, canBeForceBooked: r.canBeForceBooked, showFlag: showFlag });
        }
        if (r.unitName) {
          unitName = r.unitName;
        }
        obj = {
          startTime: startTime,
          endTime: endTime,
          unitName: unitName,
          status: r.isSucceeded ? true : false,
          date: date,
          canBeForceBooked: r.canBeForceBooked
        }
        this.statusOFBookings.push(obj);
      });

      if (_.find(that.statusOFBookings, { status: true })) {
        this.allSlotsUnavailable = false;
      } else {
        if (_.find(that.statusOFBookings, { canBeForceBooked: true }) && this.facility.isAllowForceBooking) {
          this.allSlotsUnavailable = false;
        } else {
          this.allSlotsUnavailable = true;
        }
      }
      if (_.find(that.statusOFBookings, { canBeForceBooked: true }) && this.facility.isAllowForceBooking) {
        that.isShowCanBeForceBookedMessage = true;
      } else {
        that.isShowCanBeForceBookedMessage = false;
      }
      for (let key in monthWiseBlock) {
        this.monthWiseBlock.push({ month: key, dates: monthWiseBlock[key] });
      }
    }
    this.loaderEvent.fire(true);
  }

  setCheckAvailabilityStatus() {
    if (!this.checkAvailability) {
      this.checkAvailability = this.facility.isWeeklyRepeatBooking ? true : false;
    }
  }

  setTime(flag) {
    let closeTime = this.facility.timings.closeTime == '23:59:00:00' ? '24:00' : this.facility.timings.closeTime;
    const facilityCloseTime = closeTime.split(':');
    let hour = parseInt(facilityCloseTime[0]);
    let minute = parseInt(facilityCloseTime[1]);
    const date = this.eventData.startTimeNew.date(), month = this.eventData.startTimeNew.month(), year = this.eventData.startTimeNew.year();
    let tempActivityCloseTime = moment().utcOffset(this.timezoneOffset);
    tempActivityCloseTime.set({ 'year': parseInt(year), 'month': parseInt(month), 'date': parseInt(date), 'hours': hour, 'minute': minute });
    if (tempActivityCloseTime.isBefore(this.eventData.endTimeNew) || !flag) {
      this.errMessage = CONSTANT_MESSAGES.BOOKING_WITHIN_ACTIVITY_TIMINGS_ERROR;
      this.disableDecreaseIconOfSlots = false;
      this.noCursorSlots = '';
      this.endTime = '';
      this.eventEndTime = ''
    } else {
      // 24 hour time slot changes 
      this.errMessage = '';
      this.eventEndTime = this.eventData.endTimeNew.format('HH:mm');
      this.eventEndTime = this.eventEndTime == '23:59' ? '24:00' : this.eventEndTime;
      this.endTime = this.eventData.endTimeNew.format('HH:mm');
      this.endTime = this.endTime == '23:59' ? '24:00' : this.endTime;
    }
  }

  setBookingEndTime(hour, minutes, slotDuration, bookingSlots) {
    const checkTime = parseInt(hour) * 60 + parseInt(minutes) + slotDuration * parseInt(bookingSlots)
    if (checkTime == 1440) {
      this.eventData.endTimeNew.set({ 'hours': parseInt(hour), 'minute': parseInt(minutes) + slotDuration * parseInt(bookingSlots) - 1 });
      return true;
    } else if (checkTime < 1440) {
      this.eventData.endTimeNew.set({ 'hours': parseInt(hour), 'minute': parseInt(minutes) + slotDuration * parseInt(bookingSlots) });
      return true;
    } else {
      return false;
    }
  }

  showInvoice(viewInvoice) {
    this.utilityFunctions.showInvoice(viewInvoice, this.confirmationBookingResult);
  }

  generateInvoice(bookingData, userId, bookingSlots) {
    this.loaderEvent.fire(false);
    const invoice: Invoice = {
      userId: userId,
      bookingId: bookingData.bookingId,
      facilityId: bookingData.facilityId,
      unitName: bookingData.unitName,
      activityCharges: this.facility.amount.value,
      serviceId: this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN ? this.vendor._id : this.vendor.vendorId,
      isGSTApplicable: this.facility.isGSTApplicable,
      GSTValue: this.facility.GSTValue,
      noOfPeople: bookingData.attendees,
      noOfSlotsBooked: '',
      facilityTimezoneOffset: this.facility.timezoneOffset,
      timezoneAbbr: this.facility.timezoneAbbr,
      activityName: this.facility.name,
      bookingSlots: bookingSlots,
      currency: this.facility.amount.currency
    }
    this.calendarService.generateInvoice(invoice).then((result: any) => {
      this.confirmationBookingResult = result.data;
      this.confirmationBookingResult.bookingId = bookingData.bookingId;
      this.confirmationBookingResult.userId = userId;
      this.confirmationBookingResult.vendorId = this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN ? this.vendor._id : this.vendor.vendorId,
        this.loaderEvent.fire(true);
      if (result.status == 'SUCCESS') {
        return result.invoice
      } else {
        return undefined;
      }
    });
  }

  showpaymentpopup(pymentDonePopup, message) {
    this.paymentDoneMessage = message;
    pymentDonePopup.showChildModal();
  }
}



// WEBPACK FOOTER //
// ./src/app/primecalendar/guest-booking/guest-booking.component.ts